import { gql, useApolloClient } from "@apollo/client";
import { InputField } from "@src/components/fields";
import Form from "@src/components/Form";
import {
    type GQLTrapAlarmAdminQuery,
    type GQLUpdateTrapAlarmAdminMutation,
    type GQLUpdateTrapAlarmAdminMutationVariables,
    type GQLUpdateTrapAlarmInput,
} from "@src/graphql.generated";
import { type FunctionComponent, type PropsWithChildren } from "react";
import { useIntl } from "react-intl";

export const updateTrapAlarmMutation = gql`
    mutation UpdateTrapAlarmAdmin($input: UpdateTrapAlarmInput!) {
        updateTrapAlarmAdmin(input: $input) {
            id
            name
            phone
            pin
        }
    }
`;

const EditForm: FunctionComponent<PropsWithChildren<GQLTrapAlarmAdminQuery>> = ({ trapAlarmAdmin }) => {
    const intl = useIntl();
    const client = useApolloClient();
    const { id, ...initialValues } = trapAlarmAdmin;

    const submit = ({ name, pin, phone }: GQLUpdateTrapAlarmInput) => {
        client.mutate<GQLUpdateTrapAlarmAdminMutation, GQLUpdateTrapAlarmAdminMutationVariables>({
            mutation: updateTrapAlarmMutation,
            variables: {
                input: {
                    id,
                    name,
                    phone,
                    pin,
                },
            },
        });
    };

    return (
        <Form
            mode="edit"
            onSubmit={submit}
            initialValues={initialValues}
            title={intl.formatMessage({ id: "reviermanager.trapAlarms.form.edit.title", defaultMessage: "Fallenalarm" })}
        >
            <InputField name="name" label={intl.formatMessage({ id: "reviermanager.trapAlarm.name", defaultMessage: "Name" })} />
            <InputField name="phone" label={intl.formatMessage({ id: "reviermanager.trapAlarm.phone", defaultMessage: "Telefon" })} />
            <InputField name="pin" label={intl.formatMessage({ id: "reviermanager.trapAlarm.pin", defaultMessage: "Pin" })} />
        </Form>
    );
};

export default EditForm;
